export default {"src":"/_next/static/media/FI.9927ab30.svg","height":18,"width":18};